export default "__VITE_ASSET__C9DC3Jg5__"